import { apiClient } from './axios';

// --- Airdrop ---

export interface AirdropEligibilityResponse {
  eligible: boolean;
  walletAddress: string;
  campaigns: Array<{
    id: string;
    name: string;
    amountPet: number;
    status: 'unclaimed' | 'claimed';
    claimedAt?: string;
  }>;
  totalClaimablePet: number;
  message?: string;
}

export interface ClaimAirdropRequest {
  walletAddress: string;
  campaignId?: string; // if omitted, backend may claim first eligible or all
}

export interface ClaimAirdropResponse {
  success: boolean;
  claimedAmount: number;
  transactionReference?: string;
  walletAddress: string;
  petsoWalletCredited: boolean;
  message: string;
}

export async function verifyAirdropEligibility(
  walletAddress: string
): Promise<AirdropEligibilityResponse> {
  const response = await apiClient.get<AirdropEligibilityResponse>(
    '/rewards/claims/verify-airdrop-eligibility',
    { params: { walletAddress } }
  );
  return response.data;
}

export async function claimAirdrop(
  request: ClaimAirdropRequest
): Promise<ClaimAirdropResponse> {
  const response = await apiClient.post<ClaimAirdropResponse>(
    '/rewards/claims/claim-airdrop',
    request
  );
  return response.data;
}

// --- ICO Claims ---

export interface IcoInvestmentResponse {
  found: boolean;
  walletAddress: string;
  totalPetPurchased?: number;
  claimableNow?: number;
  alreadyClaimed?: number;
  vesting?: {
    totalVestingPet: number;
    vestedSoFar: number;
    nextUnlockAt?: string;
    schedule?: string;
  };
  claimHistory?: Array<{
    amount: number;
    claimedAt: string;
    transactionReference?: string;
  }>;
  message?: string;
}

export interface ClaimIcoRequest {
  walletAddress: string;
  amount?: number; // optional; backend may use claimable amount
}

export interface ClaimIcoResponse {
  success: boolean;
  claimedAmount: number;
  transactionReference?: string;
  walletAddress: string;
  petsoWalletCredited: boolean;
  nextClaimableAt?: string;
  message: string;
}

export async function verifyIcoInvestment(
  walletAddress: string
): Promise<IcoInvestmentResponse> {
  const response = await apiClient.get<IcoInvestmentResponse>(
    '/rewards/claims/verify-ico-investment',
    { params: { walletAddress } }
  );
  return response.data;
}

export async function claimIco(
  request: ClaimIcoRequest
): Promise<ClaimIcoResponse> {
  const response = await apiClient.post<ClaimIcoResponse>(
    '/rewards/claims/claim-ico',
    request
  );
  return response.data;
}
